import { render, staticRenderFns } from "./GoogleAuth.vue?vue&type=template&id=4b63bec2&"
import script from "./GoogleAuth.vue?vue&type=script&lang=js&"
export * from "./GoogleAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports